import { postObject } from "../ChoiceApi";
import { IEReceiptPayload } from "../Models/BillingModel";

// Add an audit log entry.  Commonly used to log View actions for a screen
export async function generateEReceipt(payload: IEReceiptPayload): Promise<boolean | undefined>
{
    return postObject('api/Billing/Actions/EReceipt', payload);
}